import * as React from "react";

import { TagsChangesetEditor } from "@/shared/components/tags";
import { Device } from "@/shared/domain/devices";
import { useUpdateDevice } from "@/shared/domain/devices/hooks/useUpdateDevice";

interface UpdateDeviceTagsProps {
  device: Device;
  resourceOwnerId: string;
  readonly?: boolean;
  onTagsUpdated?: (device: Device) => void;
  onError?: (error: Error) => void;
}

export const UpdateDeviceTags: React.FC<UpdateDeviceTagsProps> = ({
  device,
  resourceOwnerId,
  readonly = false,
  onTagsUpdated,
  onError,
}) => {
  const updateDeviceMutation = useUpdateDevice();

  return (
    <TagsChangesetEditor
      tags={device.tags}
      recordKey={device.device_id}
      readonly={readonly}
      isPending={updateDeviceMutation.isPending}
      error={updateDeviceMutation.error}
      onDismissError={() => updateDeviceMutation.reset()}
      onChangeset={(changeset) =>
        updateDeviceMutation.mutate(
          {
            deviceId: device.device_id,
            resourceOwnerId,
            updates: { metadata_changeset: changeset },
          },
          { onSuccess: onTagsUpdated, onError },
        )
      }
    />
  );
};
